import React, { useCallback, useEffect, useState } from "react";
import { useThemeColor } from "../../../hooks/useThemeColor";
import { useVipClub } from "../../../hooks/useVipClub";
import { rootUrl, userKey } from "../../../App";
import LevelTables from "../VipClubTables/LevelTables";
import HistoryTables from "../VipClubTables/HistoryTables";

import "../VipClubTables/VipClubTables.css";
import { useDispatch } from "react-redux";
import { setInnerLoaderFalse, setInnerLoaderTrue } from "../../../Redux/loaderSlice";
import { showCustomSweetAlert } from "../../../Redux/customSweetAlertSlice";
import { TbRefresh } from "react-icons/tb";
import { fetchLoginUserWallet } from "../../../Redux/userSlice";

const VipClub = () => {
    const { colorMode, } = useThemeColor();
    const dispatch = useDispatch();

    const {
        availableCasback,
        allClubLevels,
        cashbackHistory,
    } = useVipClub();

    const [tableData, setTableData] = useState("Current Level");
    const [cashbackAmount, setCashbackAmount] = useState({
        cash_back_amount: 0,
    });

    const [activeRefresh, setActiveRefresh] = useState(false);

    const refreshBtn = () => {
        setActiveRefresh(true);
    };

    const calculateCashBackFunction = useCallback(async () => {

        if (!availableCasback?.id) {
            // Don’t run yet
            return;
        }

        let url = `${rootUrl}/wallet/cashback/`;
        let stringValue = localStorage.getItem(userKey);
        let value = JSON.parse(stringValue);

        let options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Token ${value?.value}`
            },
            body: JSON.stringify({
                cashback_setting_id: `${+availableCasback?.id}`
            })
        };

        if (value?.value) {
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw response;
                const data = await response.json();

                if (data.status === "ok") {
                    setCashbackAmount(data?.data);
                    return;
                }
                if (data.status === "failed") {
                    setCashbackAmount({
                        cash_back_amount: 0,
                    });
                    dispatch(showCustomSweetAlert({
                        type: "error",
                        message: `${data?.errors}`
                    }));
                    return;
                }
            } catch (error) {
                setCashbackAmount({
                    cash_back_amount: 0,
                });
            } finally {
            }
        }
    }, [availableCasback?.id, dispatch]);

    const withdrawToMainWalletFunction = async () => {

        dispatch(setInnerLoaderTrue());


        let url = `${rootUrl}/wallet/cashback/?cashback_confirm=yes`;

        let stringValue = localStorage.getItem(userKey);
        let value = JSON.parse(stringValue);

        let options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Token ${value?.value}`
            },
            body: JSON.stringify({
                cashback_setting_id: `${+availableCasback?.id}`
            })
        };

        if (value?.value) {
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw response;
                const data = await response.json();

                if (data.status === "ok") {
                    refreshBtn();
                    dispatch(fetchLoginUserWallet());
                    return;
                }
                if (data.status === "failed") {
                    dispatch(showCustomSweetAlert({
                        type: "error",
                        message: `${data?.errors}`
                    }));
                    return;
                }

            } catch (error) {
                dispatch(setInnerLoaderFalse());
            }
            finally {
                dispatch(setInnerLoaderFalse());
            }
        }
    }

    useEffect(() => {
        let refreshTimer;
        if (activeRefresh) {
            calculateCashBackFunction();
            refreshTimer = setTimeout(() => {
                setActiveRefresh(false);
            }, 1000);
        }
        return () => clearTimeout(refreshTimer);
    }, [activeRefresh, calculateCashBackFunction]);

    // console.log(availableCasback, allClubLevels);
    return (
        <>
            <section className="mx-2 mt-3">
                <div
                    className={`d-flex justify-content-center align-items-center ${colorMode === "light" ? "bg-light text-dark" : "bg-dark text-light"
                        }`}
                >
                    <div className="w-100">
                        <div
                            className={`d-flex justify-content-between align-items-center custom-shadow rounded p-3 ${colorMode === "light"
                                ? "white-background text-dark"
                                : "blackish-ash-background text-white"
                                }`}
                        >
                            {/* Left side */}
                            <div className="d-flex justify-content-start align-items-center gap-1">
                                <div>
                                    <img
                                        src={rootUrl + availableCasback?.level?.photo}
                                        alt={availableCasback?.level?.name}
                                        className="img-fluid"
                                        style={{ width: "50px", height: "50px", objectFit: "contain" }}
                                    />
                                </div>
                                <div className="d-flex flex-column align-items-start justify-content-center gap-2 text-start">
                                    <h6 className="pb-0 mb-0 fw-bold">
                                        Current level:{" "}
                                        <span className="fw-bold light-green-text">
                                            {availableCasback?.level?.category_name || `N/A`}
                                        </span>
                                    </h6>
                                    <div className="d-flex">
                                        <p className="pb-0 mb-0">
                                            <small>
                                                Cashback Balance {" "}
                                                <b>{cashbackAmount?.cash_back_amount ? (+cashbackAmount?.cash_back_amount).toFixed(2) : `0.00`}</b>
                                            </small>
                                        </p>
                                        <div className="d-flex align-items-center ms-1">
                                            <TbRefresh onClick={refreshBtn} className={activeRefresh ? "rotating pointer" : "pointer"} size={"18"} color={(colorMode === "light") ? "var(--dark)" : "var(--golden)"} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right side (buttons) */}
                            <div className="d-flex flex-column gap-2 justify-content-center">
                                <button
                                    className="btn btn-sm chocolate-button flex-fill"
                                    disabled={availableCasback?.status === false}
                                    onClick={() => withdrawToMainWalletFunction(availableCasback)}
                                >
                                    {`Withdraw to Main Wallet`}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm golden-button flex-fill fw-bold"
                                    onClick={() => setTableData(tableData === "Current Level" ? "History" : "Current Level")}
                                >
                                    {tableData === "Current Level" ? "History" : "Current Level"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mx-2 my-3">
                {
                    tableData === "Current Level" ? (
                        allClubLevels?.length > 0 ? (
                            <LevelTables data={allClubLevels} />
                        ) : (
                            <div className="d-flex justify-content-center align-items-center p-5">
                                <h5 className="text-muted">No data found</h5>
                            </div>
                        )
                    ) : tableData === "History" ? (
                        cashbackHistory?.length > 0 ? (
                            <HistoryTables data={cashbackHistory} />
                        ) : (
                            <div className="d-flex justify-content-center align-items-center p-5">
                                <h5 className="">No data found</h5>
                            </div>
                        )
                    ) : (
                        <div className="d-flex justify-content-center align-items-center p-5">
                            <h5 className="">No data found</h5>
                        </div>
                    )
                }
            </section>
        </>
    );
};

export default VipClub;